module.exports = __webpack_public_path__ + "static/media/Gratitude.870b4648.png";